interface UETConversionProps {
  eventId: string | number;
  finalPrice: number;
  currency: string;
  pageType?: string;
}

export function trackBingAdsConversion({
  eventId,
  finalPrice,
  currency,
  pageType = 'PURCHASE',
}: UETConversionProps) {
  window.uetq = window.uetq || [];
  window.uetq.push('event', 'PRODUCT_PURCHASE', {
    ecomm_prodid: eventId,
    ecomm_pagetype: pageType,
    revenue_value: finalPrice,
    currency: currency.toUpperCase() || 'USD',
  });
}
